import React, { useEffect, useState } from 'react'
import toast from "react-hot-toast"
import { useNavigate } from 'react-router-dom';
import MetaData from '../../layout/MetaData'
import { 
  usePhoneVerifyTokenMutation, 
  useResendPhoneVerificationMutation // ✅ use phone resend instead of email
} from '../../../redux/api/authApi'

const PhoneVerify = () => {
  const navigate = useNavigate()

  const [value, setValue] = useState("");
  const savedPhone = localStorage.getItem("pendingDriverPhone"); // ✅ get phone from localStorage

  const [phoneVerifyToken, { isLoading, error, isSuccess }] = usePhoneVerifyTokenMutation()
  const [resendVerification, { isLoading: isResending }] = useResendPhoneVerificationMutation()

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message)
    }
    if (isSuccess) {
      toast.success("Phone Number Verified successfully")
      localStorage.removeItem("pendingDriverPhone"); // ✅ clear after success
      navigate("/driver/login")
    }
  }, [error, isSuccess, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!savedPhone) {
      toast.error("No phone number found. Please register again.");
      return;
    }

    await phoneVerifyToken({ 
      phoneNo: savedPhone, 
      code: value 
    }); // ✅ send phoneNo + OTP
  };

  const handleResend = async () => {
    if (!savedPhone) {
      toast.error("No phone number found. Please register again.");
      return;
    }

    try {
      await resendVerification({ phoneNo: savedPhone }).unwrap(); // ✅ resend using phoneNo
      toast.success("OTP resent successfully");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to resend OTP");
    }
  };

  return (
    <>
      <MetaData title={'Phone Number Verification'} />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={handleSubmit}>
            <h2 className="mb-4">Phone Number Verification</h2>

            <div className="mb-3">
              <label htmlFor="value_field" className="form-label">Verification Code</label>
              <input
                type="text"
                id="value_field"
                className="form-control"
                name="value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                required
              />
            </div>

            <button 
              id="login_button" 
              type="submit" 
              className="btn btn-primary w-100 py-2 fw-semibold rounded-3 shadow-sm" 
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Verifying...
                </>
              ) : (
                "Verify Phone Number"
              )}
            </button>

            <div className="text-center mt-4">
              <button 
                type="button" 
                className="btn btn-primary w-100 py-2 fw-semibold rounded-3 shadow-sm" 
                onClick={handleResend}
                disabled={isResending}
              >
                {isResending ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Resending...
                  </>
                ) : (
                  "Resend OTP"
                )}
              </button>
            </div>

          </form>
        </div>
      </div>
    
    </>
  )
}

export default PhoneVerify
